var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"container gallery-container pt-4 pb-4"},[_c('div',{staticClass:"grid"},_vm._l((_vm.imgArr),function(img,index){return _c('div',{key:index,staticClass:"gallery transition-effect"},[_c('img',{staticClass:"box-shadow",attrs:{"src":img.src,"fluid":""}})])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b490898","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 166
// module chunks = 0